import { v4 as uuidv4 } from 'uuid'

import AuaIcon from 'assets/images/spons/aua.png'
import AwsIcon from 'assets/images/spons/aws.svg'
import StaffIcon from 'assets/images/spons/staff.png'
import How2bIcon from 'assets/images/spons/how2b.png'
import LimushIcon from 'assets/images/spons/limush.png'
import AmeriaIcon from 'assets/images/spons/ameria.png'
import DataartIcon from 'assets/images/spons/dataart.png'
import RearmeniaIcon from 'assets/images/spons/rearmenia.jpg'
import BrainscaleIcon from 'assets/images/spons/brainscale.png'
import PowerdmarcIcon from 'assets/images/spons/powerdmarc.png'
import SuperannotateIcon from 'assets/images/spons/superannotate.png'

import { SponsorCardInfo } from 'components/containers/Sponsors/SponsorCard'

const sponsorsData2024: SponsorCardInfo[] = [
  {
    id: uuidv4(),
    categoryName: 'PLATINUM',
    sponsors: [
      {
        id: uuidv4(),
        url: 'https://www.brainscale.cloud/',
        image: BrainscaleIcon,
        vacantions: undefined,
      },
      {
        id: uuidv4(),
        url: 'https://powerdmarc.com/',
        image: PowerdmarcIcon,
        vacantions: undefined,
      },
    ],
  },
  {
    id: uuidv4(),
    categoryName: 'GOLD',
    sponsors: [
      {
        id: uuidv4(),
        url: 'https://ameriabank.am/',
        image: AmeriaIcon,
        vacantions: undefined,
      },
    ],
  },
  {
    id: uuidv4(),
    categoryName: 'SILVER',
    sponsors: [
      {
        id: uuidv4(),
        url: 'https://www.dataart.com/',
        image: DataartIcon,
        vacantions: undefined,
      },
      {
        id: uuidv4(),
        url: 'https://www.superannotate.com/',
        image: SuperannotateIcon,
        vacantions: undefined,
      },
    ],
  },
  {
    id: uuidv4(),
    categoryName: 'SPECIAL',
    sponsors: [
      {
        id: uuidv4(),
        url: 'https://cse.aua.am/',
        image: AuaIcon,
        vacantions: undefined,
      },
      {
        id: uuidv4(),
        url: 'https://aws.amazon.com/',
        image: AwsIcon,
        vacantions: undefined,
      },
    ],
  },
  {
    id: uuidv4(),
    categoryName: 'PARTNERS',
    sponsors: [
      {
        id: uuidv4(),
        url: 'https://www.facebook.com/limushprinting/',
        image: LimushIcon,
        vacantions: undefined,
      },
      {
        id: uuidv4(),
        url: 'https://rearmenia.com/en/',
        image: RearmeniaIcon,
        vacantions: undefined,
      },
      {
        id: uuidv4(),
        url: 'https://staff.am/',
        image: StaffIcon,
        vacantions: undefined,
      },
      {
        id: uuidv4(),
        url: 'https://how2b.am/',
        image: How2bIcon,
        vacantions: undefined,
      },
    ],
  },
]

export default sponsorsData2024
